export default {
  '1W': '1 year Protection Plan',
  '3W': '3 year Protection Plan',
  '5W': '5 year Protection Plan',
  'LW': 'Lifetime Protection Plan',
};
